import React, { useMemo } from 'react';
export function StarField() {
  const stars = useMemo(() => {
    return Array.from({
      length: 50
    }).map((_, i) => {
      const size = Math.random() * 2 + 1; // 1px to 3px
      const top = Math.random() * 100;
      const left = Math.random() * 100;
      const animationDelay = Math.random() * 3;
      const animationDuration = Math.random() * 2 + 2; // 2s to 4s
      return <div key={i} className="absolute rounded-full bg-white animate-twinkle" style={{
        width: `${size}px`,
        height: `${size}px`,
        top: `${top}%`,
        left: `${left}%`,
        animationDelay: `${animationDelay}s`,
        animationDuration: `${animationDuration}s`,
        opacity: Math.random() * 0.5 + 0.3
      }} data-id="element-88" />;
    });
  }, []);
  return <div className="fixed inset-0 z-0 pointer-events-none overflow-hidden" data-id="element-89">
      {stars}
    </div>;
}